import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgFor } from '@angular/common';
import { IconComponent } from './icon.component';
import { TranslatePipe } from '../pipes/translate.pipe';
import { PREVIEW } from '../../core/preview/preview-mode';
import { PREVIEW_SCREENS } from '../../core/guards/preview-screen.guard';

interface Tab { id: string; label: string; icon: string; out: string; }
const ALL_TABS: Tab[] = [
  { id: 'home', label: 'Home', icon: 'solar:home-angle-2-bold', out: 'solar:home-angle-2-linear' },
  { id: 'menu', label: 'Menu', icon: 'solar:donut-bitten-bold', out: 'solar:donut-bitten-linear' },
  { id: 'orders', label: 'Orders', icon: 'solar:bag-check-bold', out: 'solar:bag-check-linear' },
  { id: 'account', label: 'Account', icon: 'solar:user-rounded-bold', out: 'solar:user-rounded-linear' },
];

/** Bottom navigation tab bar (mobile). */
@Component({
  selector: 'app-tab-bar',
  standalone: true,
  imports: [NgFor, IconComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div style="flex-shrink:0;display:flex;background:var(--fr-surface);border-top:1px solid var(--fr-border);
             padding-bottom:calc(6px + env(safe-area-inset-bottom));padding-top:8px;position:relative;z-index:30">
      <button *ngFor="let tb of tabs" (click)="nav.emit(tb.id)"
        style="flex:1;border:none;background:none;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:3px;padding:2px 0;position:relative">
        <app-icon [name]="active === tb.id ? tb.icon : tb.out" [size]="25"
          [color]="active === tb.id ? 'var(--brand)' : 'var(--fr-text-3)'"></app-icon>
        <span [style.font-weight]="active === tb.id ? 750 : 600"
          [style.color]="active === tb.id ? 'var(--brand-deep)' : 'var(--fr-text-3)'"
          style="font-size:10.5px;letter-spacing:-0.01em">{{ tb.label | t }}</span>
      </button>
    </div>`,
})
export class TabBarComponent {
  @Input() active = 'home';
  @Input() homeOn = true;
  @Output() nav = new EventEmitter<string>();
  get tabs(): Tab[] {
    // The admin live preview only has Home and Menu (it is read-only).
    const tabs = PREVIEW.active ? ALL_TABS.filter((t) => PREVIEW_SCREENS.includes(t.id)) : ALL_TABS;
    return this.homeOn ? tabs : tabs.filter((t) => t.id !== 'home');
  }
}
